/**
 * Created by Christof Sander on 02.03.2017.
 */

const utils = require('../../lib/utils');

module.exports = {
	config: {
		environmentDependent: true,
		showFilter: false,
		isSortable: false,
		isSelectable: false,
		showPaging: false,
		multiSelect: false,
		nrOfElementsPerPage: [
			10,
			20,
			30
		],
		directions: [
			'asc',
			'desc',
			'none'
		]
	},

	model: {
		selectedRowID: undefined,
		selectedRowIDs: {},
		actualPage: 0,
		nrOfElements: 0,
		nrOfPages: 0,
		nrOfElementsPerPage: 10,
		filters: {},
		order: []
	},

	events: {
		select: {
			type: 'click',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var $target;
				var rowIndex, rowID;
				if(event.data.component.config.isSelectable && ($target = $(event.target).closest('.base_table_row')).length > 0){
					if((rowIndex = $target.data('rowIndex')) >= 0 && (rowID = $target.data('rowId'))){
						event.data.component.toggleRow($target, rowIndex, rowID);
					}
				}
				else if(($target = $(event.target).closest('button'))){
					var pageIndex;
					if((pageIndex = $target.data('pageIndex')) !== undefined){
						event.data.component.model.actualPage = pageIndex;
						event.data.component.refresh();
					}
					else if($target.hasClass('previous')){
						if(event.data.component.model.actualPage > 0){
							event.data.component.model.actualPage--;
							event.data.component.refresh();
						}
					}
					else if($target.hasClass('next')){
						if(event.data.component.model.actualPage < event.data.component.model.nrOfPages - 1){
							event.data.component.model.actualPage++;
							event.data.component.refresh();
						}
					}
					else {
						var rowData = {};
						if((rowID = $target.data('rowID')) != undefined){
							rowData = event.data.component.getRowData(rowID)
						}
						else if($target.closest('.actionPanel').length > 0){
							rowData = event.data.component.getRowData();
						}

						// TODO: ON DELETE REMOVE SELECTED ROW ENTRY
						utils.performButtonAction(event, undefined, { rowData: rowData }).then(function(context){
							// reset selected elements if necessary
							if(context.fieldType === 'delete'){
								event.data.component.model.selectedRowID = undefined;
								event.data.component.model.selectedRowIDs = {};
								event.data.component.refresh();
							}
						});
					}
				}
			}
		},

		edit: {
			type: 'dblclick',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var $target;
				var rowIndex, rowID;
				if(($target = $(event.target).closest('.base_table_row')).length > 0){
					if((rowIndex = $target.data('rowIndex')) >= 0 && (rowID = $target.data('rowId'))){
						var rowData = {};
						if(rowData = event.data.component.getRowData(rowID)){
							event.preventDefault();
							event.stopImmediatePropagation();
							if(typeof(event.data.component.showEdit) === 'function'){
								event.data.component.showEdit('showEdit_validator', 'validator', undefined, undefined, { rowData: rowData }).then(function(context){
									event.data.component.toggleRow($target, rowIndex, rowID, true);
								});
							}
						}
					}
				}
			}
		},

		nrOfElementsPerPage: {
			type: 'change',
			selector: 'tfoot select',
			action: function(event){
				var $target = $(event.target);
				if($target.closest('.pagingNrOfElements').length > 0){
					event.data.component.model.nrOfElementsPerPage = parseInt(event.target.value);
					event.data.component.refresh();
				}
			}
		},

		filter: {
			type: 'change',
			selector: '.thead input',
			action: function(event){
				var $target = $(event.target);
				var value = $target.val();
				var fieldCode;


				// $and: {a: 5}           // AND (a = 5)
				// $or: [{a: 5}, {a: 6}]  // (a = 5 OR a = 6)
				// $gt: 6,                // > 6
				// 	$gte: 6,               // >= 6
				// 	$lt: 10,               // < 10
				// 	$lte: 10,              // <= 10
				// 	$ne: 20,               // != 20
				// 	$not: true,            // IS NOT TRUE
				// 	$between: [6, 10],     // BETWEEN 6 AND 10
				// 	$notBetween: [11, 15], // NOT BETWEEN 11 AND 15
				// 	$in: [1, 2],           // IN [1, 2]
				// 	$notIn: [1, 2],        // NOT IN [1, 2]
				// 	$like: '%hat',         // LIKE '%hat'
				// 	$notLike: '%hat'       // NOT LIKE '%hat'
				// $iLike: '%hat'         // ILIKE '%hat' (case insensitive) (PG only)
				// $notILike: '%hat'      // NOT ILIKE '%hat'  (PG only)
				// $like: { $any: ['cat', 'hat']}
				// // LIKE ANY ARRAY['cat', 'hat'] - also works for iLike and notLike
				// $overlap: [1, 2]       // && [1, 2] (PG array overlap operator)
				// $contains: [1, 2]      // @> [1, 2] (PG array contains operator)
				// $contained: [1, 2]     // <@ [1, 2] (PG array contained by operator)
				// $any: [2,3]            // ANY ARRAY[2, 3]::INTEGER (PG only)
				//
				// $col: 'user.organization_id' // = "user"."organization_id", with dialect specific column identifiers, PG in this example


				if((fieldCode = $target.data('fieldCode')) !== undefined){
					event.data.component.onFilterChanged(fieldCode, value);
				}
			}
		},

		order: {
			type: 'click',
			selector: '.thead .base_table_headCol',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var $target = $(event.target);
				var fieldCode, direction, directionIndex;

				if((fieldCode = $target.data('fieldCode')) !== undefined){
					direction       = $target.data('orderDirection');
					directionIndex  = event.data.component.config.directions.indexOf(direction) + 1;
					if(directionIndex >= event.data.component.config.directions.length) directionIndex = 0;
					direction = event.data.component.config.directions[directionIndex];

					if(!utils.keyboard.keysActive('strg')){
						event.data.component.model.order = [];
					}

					// change direction of sort field
					var o;
					var orderElementFound = false;
					for(o in event.data.component.model.order){
						if(event.data.component.model.order[o].fieldCode == fieldCode){
							if(direction === 'none'){
								event.data.component.model.order.splice(o, 1);
							}
							else {
								event.data.component.model.order[o].direction = direction;
							}
							orderElementFound = true;
							break;
						}
					}

					if(!orderElementFound && direction != 'none'){
						event.data.component.model.order.push({
							fieldCode: fieldCode,
							direction: direction
						});
					}

					event.data.component.refresh();
				}
			}
		}
	},

	methods: {
		onFilterChanged: function(fieldCode, value){
			if(value != undefined){
				this.model.filters[fieldCode] = value
			}
			else {
				delete this.model.filters[fieldCode];
			}

			this.refresh();
		},

		// TODO: DOC!
		toggleRow: function($row, rowIndex, rowID, forceSelect){
			var resetSelectedRowIDs = !this.config.multiSelect || !utils.keyboard.keysActive('strg');
			if(resetSelectedRowIDs){
				this.model.$rows.removeClass('selected');
			}
			if(this.model.selectedRowIDs[rowID] && !forceSelect){
				this.model.selectedRowID = undefined;
				if(resetSelectedRowIDs){
					this.model.selectedRowIDs = {};
				}
				else {
					$row.removeClass('selected');
					this.model.selectedRowIDs[rowID] = false;
				}
			}
			else {
				$row.addClass('selected');
				this.model.selectedRowID = rowID;
				if(resetSelectedRowIDs){
					this.model.selectedRowIDs = {};
				}
				this.model.selectedRowIDs[rowID] = true;
			}
		},

		// TODO: DOC!
		getRowData: function(rowID){
			if(rowID == undefined) rowID = this.model.selectedRowID;

			if(this.resourceData.data){
				var rowIndex;
				for(rowIndex in this.resourceData.data){
					if(
						this.resourceData.data[rowIndex].attributes &&
						this.resourceData.data[rowIndex].primaryKey &&
						this.resourceData.data[rowIndex].attributes[this.resourceData.data[rowIndex].primaryKey] == rowID
					){
						return this.resourceData.data[rowIndex];
					}
				}
			}

			return false;
		},

		// TODO: DOC!
		getSelectedRows: function(dataInclusive){
			var result = {};
			var selectedRowIDs;
			if((selectedRowIDs = Object.keys(this.model.selectedRowIDs)).length > 0){
				var k;
				result = {};
				for(k in selectedRowIDs){
					if(this.resourceData.data && this.resourceData.data[selectedRowIDs[k]]){
						if(dataInclusive)   result[selectedRowIDs[k]] = this.resourceData.data[selectedRowIDs[k]];
						else                result[selectedRowIDs[k]] = true;
					}
				}
			}

			return result;
		},

		getResourceFilters: function(){
			this.refreshMetaInfo();

			var data = {
				filters:    {},
				order:      [],
				limit:      {
					offset:  (this.model.actualPage * this.model.nrOfElementsPerPage),
					limit:   this.model.nrOfElementsPerPage
				}
			};

			var f;
			for(f in this.model.filters){
				if(this.model.filters[f] !== undefined){
					switch(this.model.fieldMapping[f].atom.dataType){
						case 'boolean':
							data.filters[f] = !!this.model.filters[f];
							break;

						default:
							data.filters[f] = {
								$like: '%' + this.model.filters[f] + '%'
							};
							break;
					}
				}
			}

			// order by first column ascending if no order has been defined
			if(this.model.order.length == 0){
				this.model.order.push({
					fieldCode:  this.model.fields[0].fieldCode,
					direction:  'asc'
				});
			}

			var o;
			for(o in this.model.order){
				data.order.push([this.model.order[o].fieldCode, this.model.order[o].direction]);
			}

			return {
				resourceQuery: data,
				metaQueries: {
					paging: {
						filters: data.filters
					}
				}
			};
		},

		sanitizeResources: function(){
			this.onResourceSanitized();
		},

		onResourceSanitized: function(){
			this.refreshMetaInfo();
		},

		refreshMetaInfo: function(){
			if(this.resourceData.meta && this.resourceData.meta.paging && this.resourceData.meta.paging.nrOfElements){
				this.model.nrOfElements = this.resourceData.meta.paging.nrOfElements;
			}
			else if(this.resourceData.data){
				this.model.nrOfElements = this.resourceData.data.length || 0;
			}
			else {
				this.model.nrOfElements = 0;
			}

			this.model.nrOfPages = this.model.nrOfElements / this.model.nrOfElementsPerPage;
			var nrOfPages;
			if(this.model.nrOfPages > (nrOfPages = parseInt(this.model.nrOfPages))) this.model.nrOfPages = Math.max(0, nrOfPages + 1);
			else                                                                    this.model.nrOfPages = Math.max(0, nrOfPages);

			if(this.model.actualPage > 0 && this.model.actualPage >= this.model.nrOfPages) this.model.actualPage = this.model.nrOfPages - 1;
		},

		onEnvironmentUpdated: function(){
			this.updateColumnWidths();
		},

		/**
		 * this function is used to update all columns' widths, which is necessary because of the overflow-y hack of table bodies.
		 */
		updateColumnWidths: function(internalCall){
			// init
			var headColumnWidths = [];
			var dataColumnWidths = [];
			var tableWidth = this.model.$table.css('display', 'table').css('height', 'auto').width();
			var width, c;
			var widthSum = 0;
			var data;
			var rowWidth;

			// measure head cells
			this.model.$bodyCols.css('width', 'auto');
			this.model.$headlineCols.css('width', 'auto');
			this.model.$firstHeadlineRowTableData.each(function(){
				data = { $: $(this) };
				data.width = data.$.width();
				headColumnWidths.push(data);
			});
			// measure body cells
			this.model.$firstBodyRowTableData.each(function(index){
				data = { $: $(this) };

				if(index == 0){
					data.$.css('width', '100%');
					rowWidth = data.$.closest('tr').width();
					data.$.css('width', 'auto');
				}

				data.width = data.$.width();
				data.maxWidth = Math.round(Math.max(headColumnWidths[index].width, data.width));
				dataColumnWidths.push(data);
				widthSum += data.maxWidth;
			});

			// calc
			var scrollBarWidth = Math.round(tableWidth - rowWidth);
			var widthFactor = rowWidth / widthSum;
			var lastIndex = dataColumnWidths.length - 1;
			var headWidth;

			// set right width
			for(c in dataColumnWidths){
				width = Math.round(widthFactor * dataColumnWidths[c].maxWidth);
				headWidth = width;

				if(c == lastIndex){
					headWidth += scrollBarWidth;
				}

				this.model.$bodyCols[c].style.width = width + 'px';
				this.model.$headlineCols[c].style.width = headWidth + 'px';
			}

			// set correct table height
			if(!internalCall){
				this.model.$body.css('height', 'auto');
				var wantedTableHeight   = this.model.$table.css('height', 'auto').height();
				var tableHeight         = this.model.$table.css('display', 'block').css('height', '100%').height();
				var tableDataHeight     = this.model.$body.height();

				if(wantedTableHeight > tableHeight){
					this.model.$body.addClass('scrollInCharge').css('height', Math.round(tableDataHeight - wantedTableHeight + tableHeight) + 'px');
				}
				else {
					this.model.$body.removeClass('scrollInCharge');
				}

				// update again: scroll bar width changes of columns may occur after height update
				this.updateColumnWidths(true);
			}
		}
	},

	hooks: {
		attach: function($element, options){
			this.model.$table                       = this.$.find('.table > table');
			this.model.$body                        = this.model.$table.find('.data table.tbody');
			this.model.$head                        = this.model.$table.find('.data table.thead');
			this.model.$firstHeadlineRowTableData   = this.model.$head.find('tr:first-child td');
			this.model.$firstBodyRowTableData       = this.model.$body.find('tr:first-child td');
			this.model.$headlineCols                = this.model.$head.find('> colgroup > col');
			this.model.$bodyCols                    = this.model.$body.find('> colgroup > col');
			this.model.$rows                        = this.model.$body.find('tr');
			this.updateColumnWidths();

			if(!options.refresh){
				var f;
				this.model.fieldMapping = {};
				for(f in this.model.fields){
					this.model.fieldMapping[this.model.fields[f].fieldCode] = this.model.fields[f];
				}
			}
		},

		onDecision: function($element, options){
			var self = this;

			switch(options.decisionComponent.componentClass) {
				case 'base_modal_modal':
					switch(options.decisionType){
						case 'submit':
							var modalContentComponent = options.decisionComponent.actions.loadContent.source.load.component;
							if(modalContentComponent && modalContentComponent.hasClass('base_form_form')){
								return modalContentComponent.submit().then(function(context){
									options.decisionComponent.hide();
									self.refresh();
								});
							}
							break;
					}
					options.decisionComponent.hide();
					break;
			}
		},

		onChildChanged: function($element, triggerOptions){
			this.onFilterChanged(triggerOptions.fieldCode, triggerOptions.value);
		}
	}
};